import { LicenseManager } from 'ag-grid-enterprise';
import MessageCenter from 'common/message-center/containers/message-center-container';
import CopsRoutes from 'common/navigation/routes/cops-routes';
import UserContainer from 'common/user/containers/user-container';
import HeaderBar from 'header/header/containers/header-container';
import LanguageProvider from 'language-provider/containers/language-provider-container';
import PropTypes from 'prop-types';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import ThemeManager from 'theme-manager/containers/theme-manager-container';
import getCOPScookie from 'utils/cookies';
import GlobalStyles from './global-styles';
import LoginProvider from './modules/login-provider/components/login-provider';
// eslint-disable-next-line max-len
import AnnouncementsSidepanelContainer from './modules/common/announcements-feed/containers/announcements-sidepanel-container';
import SocketConnection from './modules/sockets/components/socket-connection';

LicenseManager.setLicenseKey(getCOPScookie('AggridLicenseKey') || '');

const Root = ({ store }) =>
  <LoginProvider>
    <Provider store={store}>
      <LanguageProvider>
        <ThemeManager>
          <UserContainer>
            <SocketConnection>
              <Router>
                <AnnouncementsSidepanelContainer>
                  <>
                    <GlobalStyles />
                    <HeaderBar />
                    <MessageCenter />
                    <CopsRoutes />
                  </>
                </AnnouncementsSidepanelContainer>
              </Router>
            </SocketConnection>
          </UserContainer>
        </ThemeManager>
      </LanguageProvider>
    </Provider>
  </LoginProvider>;

Root.propTypes = {
  store: PropTypes.object,
};

export default Root;
